import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import TechItemModal from "./TechItemModal";
import { useDispatch, useSelector } from "react-redux";
import { setSendData, setTechnician } from "../../../Store/Slice/scheduleSlice";
import {useLazyToggleReferQuery} from "../../../Store/Builder/dashboard.api";
import {setLoader} from "../../../Store/Slice/techsbookSlice";
import showToast from "../../../Global/Hooks/toast";
import useGetTechniciansForJob from "../../../Global/Api/Schedule/getTechniciansForJob";

export default function TechItem({ item }) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const scheduleTech = useSelector((state) => state.rootReducer.scheduleSlice.tech);

  const [getAllTechniciansLocations] = useLazyToggleReferQuery();
  const getTechniciansForJob = useGetTechniciansForJob();

  const toggleRefer = async (e, id) => {
    e.stopPropagation();
    dispatch(setLoader(true));
    getAllTechniciansLocations({id})
        .unwrap()
        .then(res => {
          dispatch(setLoader(false));
          getTechniciansForJob.get();
          showToast(res?.data?.message ?? "Success", "success");
        })
        .catch((err) => {
          dispatch(setLoader(false));
          console.log(err)
          showToast(err?.data?.message ?? "Error", "error");
        });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = (item) => {
    setShowModal(true);
    setCurrentItem(item);
  };

  const handleOption = (item) => {
    setCurrentItem(item);
    dispatch(setTechnician({ technician_id: item }));
    dispatch(setSendData({ technician_id: item?.id }));
  };

  return (
    <>
      {showModal && (
        <TechItemModal closeModal={closeModal} item={currentItem} />
      )}
      <div className={`tech__item ${!item?.available ? 'tech__item-disabled' : ''}`}>
        <input
          type="radio"
          disabled={!item?.available}
          onChange={() => {
            handleOption(item);
          }}
          id={item?.id}
          name="technician"
          checked={item?.available && scheduleTech?.technician_id?.id === item.id}
        />
        <label htmlFor={item?.id}>
          <div className="tech__item-option">
            <img src="/assets/icons/check-arrow.svg" alt="check" />
          </div>
          <div className="tech__item-image">
            <img
              src={
                item?.profile_image_url
                  ? item?.profile_image_url
                  : `assets/icons/user-example.svg`
              }
              alt="user"
            />
          </div>
          <div className="tech__item-info">
            <span>
              <div className="tech__item-name">
                {item?.firstname} {item?.lastname}
              </div>
              {item?.average_rating ? (
                <div className="tech__item-rate">
                  <img src="/assets/icons/big-star-active.svg" alt="rate" />
                  <span>{item?.average_rating}</span>
                </div>
              ) : null}
            </span>
            <div className="tech__item-id">Tech ID: {item?.id}</div>
            {
                item?.tag && (
                    <>
                      <p
                        className={item?.tag}
                        data-tooltip-id={`tech-tag-${item?.id}`}
                        data-tooltip-content={item?.tag_label}
                      >
                        {item?.tag_label}
                      </p>
                      <Tooltip
                        id={`tech-tag-${item?.id}`}
                        place="top"
                        className="tech-tag-tooltip"
                      />
                    </>
                )
            }
          </div>
          <div className="tech__item-distance">
            <div className="tech__item-miles">{item?.distance_text}</div>
            <span>Estimated Mileage</span>
          </div>
          {/*{!item?.available && (*/}
          {/*  <div className="tech__item-unavailable">*/}
          {/*    <div className="tech__item-unavailableText">Unavailable</div>*/}
          {/*  </div>*/}
          {/*)}*/}
          <div className="tech__item-distance">
            <div className="tech__item-miles">{accountData?.country_currency_sign}{item?.trip_fee}</div>
            <span>Estimated Trip Fee</span>
          </div>
          <div className="tech__item-right">
            <button className="technicianCard__refer" onClick={(e) => toggleRefer(e, item?.id)}>
              {
                item?.favorite
                  ? (<img src="/assets/icons/icon-reffered.svg" alt=""/>)
                  : (<img src="/assets/icons/icon-unreffered.svg" alt=""/>)
              }
            </button>
            <div className="tech__item-button" onClick={() => {openModal(item)}}>
              <img src="/assets/icons/calendar.svg" alt="calendar" />
            </div>
          </div>

        </label>
      </div>
    </>
  );
}
